import { render, staticRenderFns } from "./ChangguanMjStatBlock.vue?vue&type=template&id=1e1b43f0&scoped=true"
import script from "./ChangguanMjStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanMjStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanMjStatBlock.vue?vue&type=style&index=0&id=1e1b43f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b43f0",
  null
  
)

export default component.exports